import { createFileRoute } from "@tanstack/react-router";
import { UserJoinPage } from "@/pages/user-join/ui/user-join-page";
import { searchParamsSchema } from "@/pages/user-join/lib/searchParamsSchema";

const UserJoinRoute = () => {
  return <UserJoinPage />;
};

export const Route = createFileRoute("/auth/join")({
  component: UserJoinRoute,
  validateSearch: searchParamsSchema,
});
